import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { Router } from '@angular/router';
import { Api } from 'src/app/core/common/api';
import { AppSettings } from 'src/app/core/common/app.settings';
import { Auth } from 'src/app/core/common/auth';
import { Configs } from 'src/app/core/common/configs';
import { ErrorTracker } from 'src/app/core/common/error.tracker';
import { Identity } from 'src/app/core/common/identity';
import { AppErrorHandler } from 'src/app/core/helpers/error.handler';
import { Initializer } from 'src/app/core/helpers/initializer';
import { Logger } from 'src/app/core/helpers/logger';
import { UI } from 'src/app/core/helpers/ui';
import { AuthInterceptor } from 'src/app/core/interceptors/auth.interceptor';
import { ErrorInterceptor } from 'src/app/core/interceptors/error.interceptor';
import { HeaderInterceptor } from 'src/app/core/interceptors/header.interceptor';
import { LoadingInterceptor } from 'src/app/core/interceptors/loading.interceptor';
import { LoggingInterceptor } from 'src/app/core/interceptors/logging.interceptor';

export const initialize = () => {
  return inject(Initializer).init();
};

export function services() {
  return [
    AppSettings,
    Logger,
    UI,
    Api,
    AppErrorHandler,
    Configs,
    ErrorTracker,
    Auth,
    Identity,
    Initializer,
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler,
    },
    provideAppInitializer(initialize),
  ];
}

export function interceptors() {
  return [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
      deps: [UI],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
      deps: [Logger],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
      deps: [Auth, Router, Api],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoggingInterceptor,
      multi: true,
    },
  ];
}

export function guards() {
  // obsolete, all guards are converted to functions, only old style service guards need to be injected here
  return [];
}
@NgModule()
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true });

    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
  public static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [...services(), ...interceptors(), ...guards()],
    };
  }
}
